var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_719_29705",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_719_29705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1751 58.2321C14.8751 58.2321 13.7501 57.7669 12.8001 56.8364C11.8501 55.9059 11.3751 54.7795 11.3751 53.4571V15.9918C11.3751 14.6695 11.8501 13.543 12.8001 12.6125C13.7501 11.682 14.8751 11.2168 16.1751 11.2168H41.3751V14.1552H16.1751C15.6251 14.1552 15.1871 14.3266 14.8611 14.6695C14.5371 15.0123 14.3751 15.453 14.3751 15.9918V53.4571C14.3751 53.9959 14.5371 54.4366 14.8611 54.7795C15.1871 55.1223 15.6251 55.2937 16.1751 55.2937H54.5001C55.0501 55.2937 55.5001 55.1223 55.8501 54.7795C56.2001 54.4366 56.3751 53.9959 56.3751 53.4571V28.8475H59.3751V53.4571C59.3751 54.7795 58.9001 55.9059 57.9501 56.8364C57.0001 57.7669 55.8501 58.2321 54.5001 58.2321H16.1751ZM52.6251 23.6318V17.7548H46.6251V14.8164H52.6251V8.93945H55.6251V14.8164H61.6251V17.7548H55.6251V23.6318H52.6251ZM21.8751 47.9475H49.3251L40.8501 36.8548L32.9751 46.6252L27.7251 40.381L21.8751 47.9475Z",
    fill: "#C1C1C1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/imgIcon.b7247ac5613aaa2b16b5ac4a304eff41.svg";
export { ForwardRef as ReactComponent };